export const stringFields = (stringData) => [
  {
    label: "Quantity",
    field: "quantity",
    value: stringData.quantity || "",
    type: "hybrid",
    options: ["N/A"],
  },
  {
    label: "Protective Device Type",
    field: "protective_type",
    value: stringData.protective_type || "",
    type: "dropdown",
    options: ["N/A", "Type II"],
  },
  {
    label: "Wiring Type",
    field: "wiring_type",
    value: stringData.wiring_type || "",
    type: "dropdown",
    options: ["H1Z2Z2-K", "IPF1", "N/A"],
  },
  {
    label: "Wiring Phase CSA",
    field: "wiring_phase_csa",
    value: stringData.wiring_phase_csa || "",
    type: "dropdown",
    options: ["4mm", "6mm", "10mm", "N/A"],
  },
  {
    label: "Wiring Earth CSA",
    field: "wiring_earth_csa",
    value: stringData.wiring_earth_csa || "",
    type: "dropdown",
    options: ["4mm", "6mm", "10mm", "N/A"],
  },
  {
    label: "Test VOC(STC)",
    field: "test_voc",
    value: stringData.test_voc || "",
    type: "number",
  },
  {
    label: "Test ISC(STC)",
    field: "test_isc",
    value: stringData.test_isc || "",
    type: "number",
  },
  {
    label: "Test Irradiance",
    field: "test_irradiance",
    value: stringData.test_irradiance || "",
    type: "dropdown",
    options: ["N/A", "✔", "✖"],
  },
  {
    label: "Polarity Check",
    field: "polarity_check",
    value: stringData.polarity_check || "",
    type: "dropdown",
    options: ["N/A", "✔", "✖"],
  },
  {
    label: "Test Voltage",
    field: "test_voltage",
    value: stringData.test_voltage || "",
    type: "dropdown",
    options: ["500", "1000", "N/A"],
  },
  {
    label: "POS Earth",
    field: "pos_earth",
    value: stringData.pos_earth || "",
    type: "dropdown",
    options: [">200", "<200", "N/A"],
  },
  {
    label: "NEG Earth",
    field: "neg_earth",
    value: stringData.neg_earth || "",
    type: "dropdown",
    options: [">200", "<200", "N/A"],
  },
  {
    label: "Earth Continuity",
    field: "earth_continuity",
    value: stringData.earth_continuity || "",
    type: "dropdown",
    options: ["✔", "✖", "N/A"],
  },
  {
    label: "Isolator DC Swith Disconnector",
    field: "isolator_dc_switch",
    value: stringData.isolator_dc_switch || "",
    type: "dropdown",
    options: [
      "KG32 T104/D-P003 KL51V",
      "KGD40 TD103/D-P003 KL11V",
      "KGD40 TD104/D-P003 KL11V",
      "KGD40B TD106/D-P003 KL11V",
      "KGD40B TD108/D-P003 KL11V",
      "N/A",
    ],
  },
  {
    label: "Location",
    field: "isolator_location",
    value: stringData.isolator_location || "",
    type: "dropdown",
    options: ["✔", "✖", "N/A"],
  },
  {
    label: "Functional Check",
    field: "isolator_functional_check",
    value: stringData.isolator_functional_check || "",
    type: "dropdown",
    options: ["✔", "✖", "N/A"],
  },
];
